import type { RevocationList, RevocationEntry } from '@slate/plugin-api';

export interface KillSwitch {
  isRevoked(pluginId: string, version: string): boolean;
  match(pluginId: string, version: string): RevocationEntry | undefined;
}

export function createKillSwitch(list: RevocationList): KillSwitch {
  const match = (pluginId: string, version: string): RevocationEntry | undefined =>
    list.revoked.find(
      (e) => e.id === pluginId && (!e.versions || e.versions.length === 0 || e.versions.includes(version)),
    );
  return { match, isRevoked: (id, v) => match(id, v) !== undefined };
}
